export type CityKey = 'sao-paulo' | 'rio-de-janeiro';
export type PeriodKey = 'agora' | 'hoje' | 'amanha' | 'fim-de-semana';

export type SeedHeatPoint = {
  id: string;
  city: CityKey;
  label: string;
  category: string;
  position: [number, number];
  confidence: number;
  expectedPeople: number;
  scores: Record<PeriodKey, number>;
};

export const cityViews: Record<CityKey, { name: string; longitude: number; latitude: number; zoom: number }> = {
  'sao-paulo': { name: 'São Paulo', longitude: -46.6333, latitude: -23.5505, zoom: 11.2 },
  'rio-de-janeiro': { name: 'Rio de Janeiro', longitude: -43.1729, latitude: -22.9068, zoom: 10.9 },
};

export const seedHeat: SeedHeatPoint[] = [
  {
    id: 'sp-vila-madalena', city: 'sao-paulo', label: 'Vila Madalena', category: 'bares e música',
    position: [-46.6902, -23.5565], confidence: 0.78, expectedPeople: 1680,
    scores: { agora: 0.82, hoje: 0.91, amanha: 0.72, 'fim-de-semana': 0.96 },
  },
  {
    id: 'sp-augusta', city: 'sao-paulo', label: 'Augusta / Baixo Centro', category: 'vida noturna',
    position: [-46.6468, -23.5548], confidence: 0.84, expectedPeople: 2260,
    scores: { agora: 0.88, hoje: 0.94, amanha: 0.76, 'fim-de-semana': 0.93 },
  },
  {
    id: 'sp-ibirapuera', city: 'sao-paulo', label: 'Ibirapuera', category: 'parque e cultura',
    position: [-46.6576, -23.5874], confidence: 0.81, expectedPeople: 1320,
    scores: { agora: 0.64, hoje: 0.79, amanha: 0.83, 'fim-de-semana': 0.91 },
  },
  {
    id: 'sp-allianz', city: 'sao-paulo', label: 'Barra Funda / Allianz', category: 'shows e esporte',
    position: [-46.6782, -23.5275], confidence: 0.69, expectedPeople: 3480,
    scores: { agora: 0.48, hoje: 0.86, amanha: 0.55, 'fim-de-semana': 0.88 },
  },
  {
    id: 'sp-pinheiros', city: 'sao-paulo', label: 'Pinheiros', category: 'gastronomia e festas',
    position: [-46.6814, -23.5677], confidence: 0.76, expectedPeople: 1900,
    scores: { agora: 0.79, hoje: 0.89, amanha: 0.73, 'fim-de-semana': 0.95 },
  },
  {
    id: 'sp-liberdade', city: 'sao-paulo', label: 'Liberdade', category: 'gastronomia e cultura',
    position: [-46.6355, -23.5584], confidence: 0.74, expectedPeople: 1180,
    scores: { agora: 0.59, hoje: 0.76, amanha: 0.80, 'fim-de-semana': 0.90 },
  },
  {
    id: 'rj-lapa', city: 'rio-de-janeiro', label: 'Lapa', category: 'samba e vida noturna',
    position: [-43.1792, -22.9130], confidence: 0.87, expectedPeople: 2520,
    scores: { agora: 0.91, hoje: 0.96, amanha: 0.77, 'fim-de-semana': 0.98 },
  },
  {
    id: 'rj-copacabana', city: 'rio-de-janeiro', label: 'Copacabana', category: 'praia e noite',
    position: [-43.1867, -22.9711], confidence: 0.83, expectedPeople: 3100,
    scores: { agora: 0.86, hoje: 0.92, amanha: 0.88, 'fim-de-semana': 0.95 },
  },
  {
    id: 'rj-ipanema', city: 'rio-de-janeiro', label: 'Ipanema', category: 'praia e gastronomia',
    position: [-43.2096, -22.9838], confidence: 0.79, expectedPeople: 2140,
    scores: { agora: 0.73, hoje: 0.87, amanha: 0.90, 'fim-de-semana': 0.94 },
  },
  {
    id: 'rj-botafogo', city: 'rio-de-janeiro', label: 'Botafogo', category: 'bares e shows',
    position: [-43.1823, -22.9519], confidence: 0.75, expectedPeople: 1760,
    scores: { agora: 0.77, hoje: 0.88, amanha: 0.69, 'fim-de-semana': 0.91 },
  },
  {
    id: 'rj-maracana', city: 'rio-de-janeiro', label: 'Maracanã', category: 'esporte e grandes eventos',
    position: [-43.2302, -22.9121], confidence: 0.67, expectedPeople: 4200,
    scores: { agora: 0.35, hoje: 0.81, amanha: 0.42, 'fim-de-semana': 0.84 },
  },
  {
    id: 'rj-centro', city: 'rio-de-janeiro', label: 'Centro / Praça Mauá', category: 'cultura e eventos',
    position: [-43.1801, -22.8943], confidence: 0.72, expectedPeople: 1390,
    scores: { agora: 0.62, hoje: 0.78, amanha: 0.74, 'fim-de-semana': 0.87 },
  },
];
